export default {
    namespaced: true,
    state: {
        opened: false,
        menu: false,
        subMenu: false,
    },
    getters: {
        getAvailable: state => (!!state.menu || !!state.subMenu),
        getMenu: state => state.menu || state.subMenu || undefined,
        getSubMenu: state => state.menu ? (state.subMenu || undefined) : undefined,
        getOpened: state => !!state.opened,
    },
    mutations: {
        setMenu: (state, menu) => state.menu = (menu || false),
        setSubMenu: (state, subMenu) => state.subMenu = (subMenu || false),
        setOpened: (state, opened) => state.opened = !!opened,
        toggleOpened: state => state.opened = !state.opened,
    },
    actions: {
        async setMenu(context, menu) {
            return context.commit('setMenu', menu);
        },
        async setSubMenu(context, subMenu) {
            return context.commit('setSubMenu', subMenu);
        },
        async setOpened(context, opened) {
            return context.commit('setOpened', !!opened);
        },
        async toggleOpened(context) {
            return context.commit('toggleOpened');
        },
    }
}